import { useRef, memo, useEffect, React } from "react";
import { useI18n } from "../../i18n/I18nContext";

function BurgerItem({
  id,
  name,
  ingredients,
  image,
  keyIngredient,
  keyIngredientImage,
  bestBuy,
  selected,
  SelectBurgerItem,
  isMobile,
}) {
  const { t } = useI18n();
  //izracunaj visinu accordion contenta
  const accordionContentRef = useRef(null);

  let height = accordionContentRef.current?.scrollHeight;
  if (!selected) height = 0;

  useEffect(() => {
    console.log("render burger item!");
  });
  return (
    <>
      <div
        className={`${selected ? "selected " : ""} single-burger-container`}
        onClick={() => {
          SelectBurgerItem(id);
        }}
      >
        <div className="shining-helper"></div>
        {/* Image of burger */}
        <div className="burger-img-wrapper">
          <img
            src={`${image.substring(0, image.indexOf("."))}.webp`}
            alt={t("alt.burger")}
          />
        </div>
        <div className="burger-info">
          <h3>{name}</h3>
        </div>
        <div className="accordion-arrow-wrapper">
          <img src="images/strelica.webp" alt={t("alt.accordionArrow")} />
        </div>

        {/* best buy ribbon */}
        {bestBuy ? <span className="best-buy-ribbon"> </span> : ""}
      </div>
      {/* ZA MOBILNI, prikaz detaljniji */}
      {isMobile ? (
        <div
          ref={accordionContentRef}
          className={`${selected ? "expanded" : ""}
           big-burger-accordion-container`}
          style={{ minHeight: height }}
        >
          <div className="burger-img-wrapper">
            <img src={image} alt={t("alt.burger")} />
          </div>
          <div className="burger-ingredients-container">
            <h5>{t("burgersSection.ingredientsLabel")}</h5>
            <p>{ingredients}</p>
            {/* 100% beef and other characteristic */}
            <div className="burger-characteristic">
              <div className="single-burger-characteristic">
                <div className="beef-img-wrapper">
                  <img src="images/kravica.webp" alt={t("alt.cow")} />
                </div>
                <p>{t("burgersSection.beefLabel")}</p>
              </div>
              <div className="single-burger-characteristic">
                <div className="beef-img-wrapper">
                  <img src={keyIngredientImage} alt={t("alt.characteristic")} />
                </div>
                <p>{keyIngredient}</p>
              </div>
            </div>
            {/* <h6>
              <span>156 dinara</span>
            </h6> */}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

function areEqual(prevProps, nextProps) {
  if (
    prevProps.id == nextProps.id &&
    prevProps.selected == nextProps.selected
  ) {
    return true;
  }
  return false;
}

export default memo(BurgerItem, areEqual);
